<template>
  <div class="rule scroll-touch">
    <p>优惠券使用说明</p>
    <section v-for="items in desc" :key="items.title">
      <p>{{ items.title }}</p>
      <p v-for="(item,index) in items.list" :key="index">{{ item }}</p>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      desc: [
        {
          title: '一．什么是芒果好物优惠劵？',
          list: ['由芒果好物发放，可用且仅用于抵扣芒果好物商品订单金额'],
        },
        {
          title: '二．芒果好物优惠券使用规则',
          list: [
            '1.优惠券不可叠加使用',
            '2.优惠劵应在劵面载明的有效期内使用，过期作废',
            '3.优惠劵须在订单满足券面要求的订单金额（不含运费）时才能使用',
            '4.优惠券的金额大于订单应付金额时，差额部分不予退回',
            '5.预售商品不支持使用优惠券',
            '6.如用户对包含了多个商品的订单使用了优惠券，会将商品优惠券按比例抵扣到每个商品。单个商品退款时，会按优惠比例减免后的付款商品价格退款',
            '7.使用优惠劵后，订单发生退货，代金劵不予退还',
            '8.如芒果好物已发放代金劵存在有失公平、不符合运营目的情形，芒果好物有权将您的代金劵冻结或者关闭。您未使用的优惠劵将进行冻结',
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.rule {
  height: 100%;
  font-size: 24px;
  line-height: 33px;
  color: #7b7b7b;

  section {
    margin-bottom: 40px;
  }
}
</style>
